export default [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "home" */ '@/modules/home/views/Home.vue'),
    // beforeEnter: (to, from, next) => {
    //   if (localStorage.getItem('updatedHomePagePreference') == 'a') {
    //     next();
    //   } else {
    //     next('/2');
    //   }
    
    // }
  },
  {
    path: '/profiles',
    name: 'FreelancerList',
    component: () => import(/* webpackChunkName: "home" */ '@/modules/home/views/freelancers/Freelancer.vue')
  },
  {
    path: '/category',
    name: 'Category',
    component: () => import(/* webpackChunkName: "home" */ '@/modules/home/views/category/Category.vue')
  },
  // {
  //   path: '/2',
  //   name: 'Homev2',
  //   component: () => import(/* webpackChunkName: "home" */ '@/modules/home/views/Homev2.vue'),
  //   beforeEnter: (to, from, next) => {
  //     if (localStorage.getItem('updatedHomePagePreference') == 'b') {
  //       next();
  //     } else {
  //       next('/');
  //     }
  //   }
  // },
  {
    path: '/notFound',
    name: 'NotFound',
    component: () => import(/* webpackChunkName: "home" */ '@/modules/home/views/NotFound.vue')
  }
]
